"use client";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import WorkspaceShimmer from "@/components/common/WorkspaceShimmer";

export default function AuthWrapper({ children }) {
  const router = useRouter();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  useEffect(() => {
    const loggedIn = sessionStorage.getItem("isLogin");
    if (loggedIn) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      router.replace("/"); // Redirect to login page
    }
  }, []);
  if (isAuthenticated === null) {
    return <WorkspaceShimmer />;
  }

  return <>{children}</>;
}
